module.exports = __webpack_public_path__ + "img/password.74fbe7ef.svg";